import React from 'react';

interface LoadingSpinnerProps {
  title?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ title = "Loading..." }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      zIndex: 9999
    }}>
      <div style={{ textAlign: 'center' }}>
        <img
          src="/execdash_symbol.png"
          alt="Loading..."
          style={{
            width: '64px',
            height: '64px',
            animation: 'spin 1s linear infinite'
          }}
        />
        <div style={{
          marginTop: '16px',
          fontSize: '1.2rem',
          color: '#666',
          fontWeight: '500'
        }}>
          {title}
        </div>
      </div>
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;
